/**
 * Dynamic Personal Images Loader
 *
 * This utility loads all images from public/images/personal/ folder.
 *
 * USAGE: Simply add any image file (jpg, jpeg, png, webp, gif) to
 * the public/images/personal/ folder and it will automatically
 * appear in the card stack.
 *
 * NOTE: Since Create React App serves public folder statically,
 * we maintain a manifest file that gets updated. For fully dynamic
 * loading, you would need a backend or build-time script.
 *
 * To add new images:
 * 1. Add image to public/images/personal/
 * 2. Run: npm run update-images (or manually add to the list below)
 */

// Manifest of images in public/images/personal/
// This list is the source of truth - add your image filenames here
const IMAGE_MANIFEST = [
    'zkfzmeerbv7kie9bysq2.webp',
    'ajndyatovaj0cp1hfxc4.webp',
    'ao4ghr2aj6gabktwrjmf.webp',
    'f15nsdb5eicwe8ma9xza.webp',
    'reorhmtuu1ui9icydmuu.webp',
    'c7ausiydnbx7zdbwy7ap.webp',
    'rydxamiyamspkbywcigf.webp',
    'taoflmxvuovcrzwrmkn2.webp',
    'u8gqdlv9hfpkqitn1oio.webp',
    'vrx0ywdydj7rjzitwyqb.webp',
    'wa0xofu9zxpu01ezytau.webp',
    'wjfolinqsgfcxvyzzot8.webp',
    'xvrzkgmgoqzo9y40n5fi.webp',
    'mountain-trek-1.webp',
    'mountain-trek-2.webp',
    'mountain-trek-3.webp',
    'mountain-trek-4.webp',
    'mountain-trek-5.webp',
    'mountain-trek-6.webp',
    'sunset-moon.webp',
    'sunset-city.webp',
    'sunset-street.webp',
    'cloud-peak.webp',
    'sunrise-trees.webp',
    'sunset-silhouette.webp',
];

// Shuffle array using Fisher-Yates algorithm
const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
};

/**
 * Get all personal images for the card stack
 * @param {Object} options - Configuration options
 * @param {boolean} options.shuffle - Whether to shuffle the images (default: true)
 * @param {number} options.limit - Max number of images to return (default: all)
 * @returns {Array} Array of image objects with src and alt
 */
export const getPersonalImages = (options = {}) => {
    const { shuffle = true, limit = null } = options;

    let images = IMAGE_MANIFEST.map((filename, index) => ({
        src: `/images/personal/${filename}`,
        alt: `Personal moment ${index + 1}`,
        filename,
    }));

    if (shuffle) {
        images = shuffleArray(images);
    }

    if (limit && limit > 0) {
        images = images.slice(0, limit);
    }

    return images;
};

/**
 * Add a new image to the manifest
 * (For documentation - actual addition requires editing this file)
 */
export const IMAGE_FOLDER_PATH = '/images/personal/';

export default getPersonalImages;
